import { render } from "./CarouselsPage.vue?vue&type=template&id=687de89c&ts=true"
import script from "./CarouselsPage.vue?vue&type=script&lang=ts"
export * from "./CarouselsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__